import {useQuery} from "@tanstack/react-query";
import {readWonUnitSelectBoxApi,} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 환율 단위 select box
 * @param props
 * @returns
 */
export const useReadWonUnitSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readWonUnitSelectBoxApi"],
        queryFn: async () => await readWonUnitSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
